import { Link } from "react-router";
import React, { Component, useState, useEffect } from 'react';
import { Navbar, Container, Nav, NavDropdown, Dropdown, Button, ButtonGroup, SplitButton } from 'react-bootstrap';

import './TopNav.scss';
import logo from '../../assets/img/logo/logo-facturexl.svg'
import logoSmall from '../../assets/img/logo/logo-facturexl-small.png'
import { FolderService } from '../../services/FolderService'
import { UserService } from '../../services/UserService'
import { GlobalContext } from "../../services/GlobalProvider";
import { useNavigate, useParams, useSearchParams, useLocation } from "react-router";
import { granted, getDomainFromUrl, setCookie, getCookie } from '../../helper/Helper'
import ShortCuts from './shortcuts/ShortCuts';
import ChangePasswordDialog from "./change-password-dialog/ChangePasswordDialog";
import ChangeEmailDialog from "./change-email-dialog/ChangeEmailDialog";
import RapportDialog from "./rapport-dialog/RapportDialog";


const TopNav = () => {

  const { userDetails, folderDetails, grants, folders, setFolderDetails, preferences, parametres, globalContextLoaded } = React.useContext(GlobalContext);

  const [currentPage, setCurrentPage] = useState()
  const [changePasswordDialog, setResetPasswordDialog] = useState({})
  const [changeEmailDialog, setChangeEmailDialog] = useState({})
  const [rapportDialog, setRapportDialog] = useState({})

  let location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    let segment = location.pathname.split("/")[2];
    setCurrentPage(segment)
  }, [location.pathname]);

  function logout() {
/*     let idToken = getCookie('id_token')

    // remove cookies 
    sessionStorage.removeItem('access_token');
    setCookie("id_token", '', -10, getDomainFromUrl(global.config._FRONT_URL_))
    setCookie("refresh_token", '', -10, getDomainFromUrl(global.config._FRONT_URL_)) */

    let redirectUri = global.config._FRONT_URL_
    window.location.href = global.config._OAUTH_PUBLIC_URL_ + "/protocol/openid-connect/logout?client_id=" +  global.config._OAUTH_CLIENT_ID_ + "&post_logout_redirect_uri=" + redirectUri + "/authentication/logout"
  }

  function changeFolder(folder) {
    setFolderDetails(folder)
    navigate(`/${folder?.dossier?._id}/accueil`)
  }

  return (
    <>

      <RapportDialog show={rapportDialog.show} setCloseModal={() => setRapportDialog({ show: false })} />
      <ChangePasswordDialog show={changePasswordDialog.show} setCloseModal={() => setResetPasswordDialog({ show: false })} />
      <ChangeEmailDialog show={changeEmailDialog.show} setCloseModal={() => setChangeEmailDialog({ show: false })} />

      <Navbar id="topNav" bg="primary-500" variant="dark" expand="md" fixed="top" className="py-2">
        <Container fluid>
          <Navbar.Brand className="d-xl-none" href={globalContextLoaded ? `/${folderDetails?.dossier?._id}/accueil` : null}><img className="me-2" src={logoSmall} alt="Logo XL Prog" /></Navbar.Brand>
          <Navbar.Brand className="d-none d-xl-block" href={globalContextLoaded ? `/${folderDetails?.dossier?._id}/accueil` : null}><img className="me-2 main-logo" src={logo} alt="Logo XL Prog" /></Navbar.Brand>
          <Navbar.Toggle aria-controls="id-top-nav" /> {/* Utile au responsive */}

          <Navbar.Collapse id="id-top-nav">

            {globalContextLoaded &&
              <>

                <Button className={"me-2 " + (!granted(grants, "clients") && "disabled")} variant={["clients"].indexOf(currentPage) > -1 ? "light" : "primary-600"} as={Link} to={`${folderDetails?.dossier?._id}/clients`}>Clients</Button>

                <Dropdown as={ButtonGroup} className="me-2">
                  <Button className={!granted(grants, "articles") && "disabled"} variant={["articles", "fournisseurs", "tarifs"].indexOf(currentPage) > -1 ? "light" : "primary-600"} as={Link} to={`${folderDetails?.dossier?._id}/articles`}>Articles</Button>
                  <Dropdown.Toggle split variant={["articles", "fournisseurs", "tarifs"].indexOf(currentPage) > -1 ? "light" : "primary-600"} />
                  <Dropdown.Menu>
                    <Dropdown.Item className={!granted(grants, "articles") && "disabled"} as={Link} to={`${folderDetails?.dossier?._id}/articles`}>Articles</Dropdown.Item>
                    <Dropdown.Item className={!granted(grants, "fournisseurs") && "disabled"} as={Link} to={`${folderDetails?.dossier?._id}/fournisseurs`}>Fournisseurs</Dropdown.Item>
                    <Dropdown.Item className={!granted(grants, "tarifs") && "disabled"} as={Link} to={`${folderDetails?.dossier?._id}/tarifs`}>Tarifs & Promotions</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown as={ButtonGroup} className="me-2">
                  <Button className={"d-inline-flex " + ((!granted(grants, "factures") && (!granted(grants, "brouillons"))) && "disabled")} variant={["factures", "reglements", "proformas", "abonnements"].indexOf(currentPage) > -1 ? "light" : "primary-600"} as={Link} to={`${folderDetails?.dossier?._id}/factures`}>Facturation{preferences?.factures?.currentDraft && <i className="ps-3 ms-auto material-icons text-warning">fiber_manual_record</i>}</Button>
                  <Dropdown.Toggle split variant={["factures", "reglements", "proformas", "abonnements"].indexOf(currentPage) > -1 ? "light" : "primary-600"} />
                  <Dropdown.Menu>
                    <Dropdown.Item className={"d-inline-flex " + ((!granted(grants, "factures") && (!granted(grants, "brouillons"))) && "disabled")} as={Link} to={`${folderDetails?.dossier?._id}/factures`}>Factures{preferences?.factures?.currentDraft && <i className="ps-3 ms-auto material-icons text-warning">fiber_manual_record</i>}</Dropdown.Item>
                    <Dropdown.Item className={"d-inline-flex " + (!granted(grants, "reglements") && "disabled")} as={Link} to={`${folderDetails?.dossier?._id}/reglements`}>Reglements</Dropdown.Item>
                    <Dropdown.Item className={"d-inline-flex " + ((!granted(grants, "proformas") && (!granted(grants, "brouillons"))) && "disabled")} as={Link} to={`${folderDetails?.dossier?._id}/proformas`}>Proformas{preferences?.proformas?.currentDraft && <i className="ps-3 ms-auto material-icons text-warning">fiber_manual_record</i>}</Dropdown.Item>
                    <Dropdown.Item className={"d-inline-flex " + ((!granted(grants, "abonnements") && (!granted(grants, "brouillons"))) && "disabled")} as={Link} to={`${folderDetails?.dossier?._id}/abonnements`}>Abonnements{preferences?.abonnements?.currentDraft && <i className="ps-3 ms-auto material-icons text-warning">fiber_manual_record</i>}</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <Button /* disabled={!granted(grants, "editions")} */ className="me-2" variant={["editions"].indexOf(currentPage) > -1 ? "light" : "primary-600"} as={Link} to={`${folderDetails?.dossier?._id}/editions`}>Editions</Button>
              </>
            }

            <Nav className="ms-auto d-flex align-items-center">

              {globalContextLoaded &&
                <Button className={"me-2 " + (!granted(grants, "admin") && "disabled")} variant={["administration"].indexOf(currentPage) > -1 ? "light" : "primary-600"} as={Link} to={`${folderDetails?.dossier?._id}/administration`}><i className="material-icons me-2 float-start">settings</i>Paramètres</Button>
              }

              {folders?.length > 1 &&
                <Dropdown align="end" className="me-2">
                  <Dropdown.Toggle variant="primary-600">
                    <i className="material-icons me-2 float-start">folder</i>
                    {folderDetails?.dossier?.nom ? folderDetails?.dossier?.nom : "Dossiers"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {folders.map((folder, i) => (
                      <Dropdown.Item key={i} onClick={() => changeFolder(folder)}>{folder?.dossier?.nom}</Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              }

              {userDetails &&
                <>
                  <Dropdown align="end" className="me-2">
                    <Dropdown.Toggle variant="primary-600">
                      <i className="material-icons me-2 float-start">person</i>
                      {userDetails?.name}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.ItemText>{userDetails?.email}</Dropdown.ItemText>
                      <Dropdown.Divider />
                      <Dropdown.Item onClick={() => setRapportDialog({ "show": true })}>Signaler une erreur</Dropdown.Item>
                      <Dropdown.Divider />
                      {/* <Dropdown.Item onClick={() => setRapportDialog({ "show": true })}>Signaler un bug & suggestions</Dropdown.Item> */}
                      <Dropdown.Item onClick={() => setChangeEmailDialog({ "show": true })}>Changer l'adresse email de connexion</Dropdown.Item>
                      <Dropdown.Item onClick={() => setResetPasswordDialog({ "show": true })}>Réinitialiser le mot de passe</Dropdown.Item>
                      <Dropdown.Item onClick={() => logout()}>Déconnexion</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <ShortCuts />
                </>
              }

              {!userDetails &&
                <Nav.Link onClick={() => UserService.redirectToExternalLogin()}>Se connecter</Nav.Link>
              }

            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

    </>
  );

}

export default TopNav;